/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActiveModel } from '../models/ActiveModel';
import type { Address } from '../models/Address';
import type { ApiQueryLog } from '../models/ApiQueryLog';
import type { AppointmentTypeModel } from '../models/AppointmentTypeModel';
import type { AutotraderValuationDTO } from '../models/AutotraderValuationDTO';
import type { BankAccountResponseDto } from '../models/BankAccountResponseDto';
import type { BaseSmsTemplate } from '../models/BaseSmsTemplate';
import type { BookingTypeSubmitModel } from '../models/BookingTypeSubmitModel';
import type { BrandCodeDto } from '../models/BrandCodeDto';
import type { CapHpiDvlaDTO } from '../models/CapHpiDvlaDTO';
import type { CapValuationDTO } from '../models/CapValuationDTO';
import type { CarMinFilter } from '../models/CarMinFilter';
import type { ConvertedPartPdfFullModel } from '../models/ConvertedPartPdfFullModel';
import type { ConvertedServicePartPdfGroupLabourSubmitModel } from '../models/ConvertedServicePartPdfGroupLabourSubmitModel';
import type { ConvertedServicePartPdfGroupPartSubmitModel } from '../models/ConvertedServicePartPdfGroupPartSubmitModel';
import type { ConvertedServicePartPdfSubmitModel } from '../models/ConvertedServicePartPdfSubmitModel';
import type { CreateRepairOrderResponse } from '../models/CreateRepairOrderResponse';
import type { ExternalContractorDtoPagedListData } from '../models/ExternalContractorDtoPagedListData';
import type { ExternalContractorInput } from '../models/ExternalContractorInput';
import type { FAQLog } from '../models/FAQLog';
import type { FAQLogType } from '../models/FAQLogType';
import type { FinanceDictionaries } from '../models/FinanceDictionaries';
import type { HealthCheckResultModel } from '../models/HealthCheckResultModel';
import type { LabourDetailsModel } from '../models/LabourDetailsModel';
import type { LabourSubmitModel } from '../models/LabourSubmitModel';
import type { LogInput } from '../models/LogInput';
import type { LookupStockInfoResponse } from '../models/LookupStockInfoResponse';
import type { LookUpUserDto } from '../models/LookUpUserDto';
import type { ManagersValuationDTO } from '../models/ManagersValuationDTO';
import type { ManufacturerDto } from '../models/ManufacturerDto';
import type { MotHistoryDTO } from '../models/MotHistoryDTO';
import type { MotRequestSource } from '../models/MotRequestSource';
import type { ParsedEsaModel } from '../models/ParsedEsaModel';
import type { PartRequestWipInfoInputModel } from '../models/PartRequestWipInfoInputModel';
import type { RacContractModel } from '../models/RacContractModel';
import type { ReferenceUnitMeasurementDto } from '../models/ReferenceUnitMeasurementDto';
import type { RepairOrderQuoteClientModel } from '../models/RepairOrderQuoteClientModel';
import type { RepairOrderQuoteClientSubmitModel } from '../models/RepairOrderQuoteClientSubmitModel';
import type { RepairOrderQuoteLabourSubmitModel } from '../models/RepairOrderQuoteLabourSubmitModel';
import type { RepairOrderQuoteModel } from '../models/RepairOrderQuoteModel';
import type { RepairOrderQuotePartCreateResponseModel } from '../models/RepairOrderQuotePartCreateResponseModel';
import type { RepairOrderQuotePartSubmitModel } from '../models/RepairOrderQuotePartSubmitModel';
import type { RepairOrderQuoteStatusModel } from '../models/RepairOrderQuoteStatusModel';
import type { RepairOrderQuoteStatusSubmitModel } from '../models/RepairOrderQuoteStatusSubmitModel';
import type { RepairOrderQuoteSubmitModel } from '../models/RepairOrderQuoteSubmitModel';
import type { RepairOrderSubmitModel } from '../models/RepairOrderSubmitModel';
import type { ResponseVehicleData } from '../models/ResponseVehicleData';
import type { SendMmsInput } from '../models/SendMmsInput';
import type { ServiceHistoryCheckModel } from '../models/ServiceHistoryCheckModel';
import type { ServiceHistoryCheckSubmitModel } from '../models/ServiceHistoryCheckSubmitModel';
import type { ServiceHistoryCheckTypeModel } from '../models/ServiceHistoryCheckTypeModel';
import type { ShortCustomModelDTO } from '../models/ShortCustomModelDTO';
import type { ShortSoHeaderInfoModel } from '../models/ShortSoHeaderInfoModel';
import type { ShortTrimStyleDTO } from '../models/ShortTrimStyleDTO';
import type { SmsTemplateDto } from '../models/SmsTemplateDto';
import type { SmsTemplateParams } from '../models/SmsTemplateParams';
import type { SoHeaderDueDatesUpdateModel } from '../models/SoHeaderDueDatesUpdateModel';
import type { SoHeaderInnerRepairOrderJobModel } from '../models/SoHeaderInnerRepairOrderJobModel';
import type { SoHeaderRepairOrderUpdateModel } from '../models/SoHeaderRepairOrderUpdateModel';
import type { SoHeaderTrackerModel } from '../models/SoHeaderTrackerModel';
import type { SoHeaderTrackerSubmitModel } from '../models/SoHeaderTrackerSubmitModel';
import type { SoOperModel } from '../models/SoOperModel';
import type { SoPartStatusDto } from '../models/SoPartStatusDto';
import type { SortTypeEnum } from '../models/SortTypeEnum';
import type { SupplierTypeEnum } from '../models/SupplierTypeEnum';
import type { SvcFeedbackRequest } from '../models/SvcFeedbackRequest';
import type { TradeInConditionDto } from '../models/TradeInConditionDto';
import type { TransportOptionModel } from '../models/TransportOptionModel';
import type { TransportOptionSubmitModel } from '../models/TransportOptionSubmitModel';
import type { TrimStyleDTO } from '../models/TrimStyleDTO';
import type { VariantCodeModel } from '../models/VariantCodeModel';
import type { VehicleData } from '../models/VehicleData';
import type { VoucherModel } from '../models/VoucherModel';
import type { WarrantyJobTypeEnum } from '../models/WarrantyJobTypeEnum';
import type { WipServicePdfModel } from '../models/WipServicePdfModel';
import type { WipServicePdfTypeEnum } from '../models/WipServicePdfTypeEnum';
import type { YoutubeUpdateInput } from '../models/YoutubeUpdateInput';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CommonService {

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static getCommonGetLog(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Common/GetLog',
    });
  }

  /**
   * Get server UTC DateTime
   * @returns string Success
   * @throws ApiError
   */
  public static getCommonUtcDateTime(): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/utc-date-time',
      errors: {
        500: `Server Error`,
      },
    });
  }

  /**
   * Lookup addresses by postcode or part postcode
   * @param postcode postcode or part postcode
   * @returns Address Success
   * @throws ApiError
   */
  public static getLookupAddress(
postcode: string,
): CancelablePromise<Array<Address>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/LookupAddress',
      query: {
        'postcode': postcode,
      },
      errors: {
        500: `Server Error`,
      },
    });
  }

  /**
   * Get Finance Apply dictionaries
   * @returns FinanceDictionaries Success
   * @throws ApiError
   */
  public static getGetFinanceApplyDictionaries(): CancelablePromise<FinanceDictionaries> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetFinanceApplyDictionaries',
      errors: {
        500: `Server Error`,
      },
    });
  }

  /**
   * Get delivery price
   * @param postcode 
   * @param branchId 
   * @returns number Success
   * @throws ApiError
   */
  public static getGetDeliveryPrice(
postcode?: string,
branchId?: number,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetDeliveryPrice',
      query: {
        'postcode': postcode,
        'branchId': branchId,
      },
      errors: {
        500: `Server Error`,
      },
    });
  }

  /**
   * @param saleOfferId 
   * @returns AutotraderValuationDTO Success
   * @throws ApiError
   */
  public static getLookUpAutotraderValuation(
saleOfferId?: number,
): CancelablePromise<Array<AutotraderValuationDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/LookUpAutotraderValuation',
      query: {
        'saleOfferId': saleOfferId,
      },
    });
  }

  /**
   * @param regNo 
   * @param mileage 
   * @returns any Success
   * @throws ApiError
   */
  public static getLookUpAutotraderVehicleMetrics(
regNo?: string,
mileage?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/LookUpAutotraderVehicleMetrics',
      query: {
        'regNo': regNo,
        'mileage': mileage,
      },
    });
  }

  /**
   * @param saleOfferId 
   * @returns MotHistoryDTO Success
   * @throws ApiError
   */
  public static getLookUpMotHistory(
saleOfferId?: number,
): CancelablePromise<MotHistoryDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/LookUpMotHistory',
      query: {
        'saleOfferId': saleOfferId,
      },
    });
  }

  /**
   * @param regNo 
   * @param source
 *
 * 0 = ServiceBooking
 *
 * 1 = WipAppointmentPreparation
 *
 * 2 = WorkshopCheckin
 *
 * 3 = WorkshopLog
   * @param sourceId 
   * @param userId 
   * @returns MotHistoryDTO Success
   * @throws ApiError
   */
  public static getLookUpMotHistoryWithRegNo(
regNo: string,
source?: MotRequestSource,
sourceId?: number,
userId?: number,
): CancelablePromise<MotHistoryDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/LookUpMotHistoryWithRegNo/{regNo}',
      path: {
        'regNo': regNo,
      },
      query: {
        'source': source,
        'sourceId': sourceId,
        'userId': userId,
      },
    });
  }

  /**
   * @param regNo 
   * @returns any Success
   * @throws ApiError
   */
  public static getLookUpMotHistoryByRegno(
regNo: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/LookUpMotHistoryByRegno/{regNo}',
      path: {
        'regNo': regNo,
      },
    });
  }

  /**
   * @param saleOfferId 
   * @returns ManagersValuationDTO Success
   * @throws ApiError
   */
  public static getLookUpManagerValuations(
saleOfferId?: number,
): CancelablePromise<ManagersValuationDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/LookUpManagerValuations',
      query: {
        'saleOfferId': saleOfferId,
      },
    });
  }

  /**
   * @param regNo 
   * @param mileage 
   * @param source 
   * @returns CapValuationDTO Success
   * @throws ApiError
   */
  public static getLookUpCapValuations(
regNo?: string,
mileage?: number,
source: string = 'Common - Look Up Cap Valuations',
): CancelablePromise<CapValuationDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/LookUpCapValuations',
      query: {
        'regNo': regNo,
        'mileage': mileage,
        'source': source,
      },
    });
  }

  /**
   * @param regNo 
   * @param mileage 
   * @param capId 
   * @param dateFirstReg 
   * @param vehicleType 
   * @returns CapValuationDTO Success
   * @throws ApiError
   */
  public static getLookUpCapValuationByCapId(
regNo?: string,
mileage?: number,
capId?: number,
dateFirstReg?: string,
vehicleType: string = 'CAR',
): CancelablePromise<CapValuationDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/LookUpCapValuationByCapId',
      query: {
        'regNo': regNo,
        'mileage': mileage,
        'capId': capId,
        'dateFirstReg': dateFirstReg,
        'vehicleType': vehicleType,
      },
    });
  }

  /**
   * @param enquiryCrmId 
   * @returns any Success
   * @throws ApiError
   */
  public static getLookUpEnquiryCdk(
enquiryCrmId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/LookUpEnquiryCDK',
      query: {
        'enquiryCrmId': enquiryCrmId,
      },
    });
  }

  /**
   * @returns string Success
   * @throws ApiError
   */
  public static getGetTitles(): CancelablePromise<Record<string, string>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetTitles',
    });
  }

  /**
   * @param customModelId 
   * @returns CarMinFilter Success
   * @throws ApiError
   */
  public static getGetFuelAndTransmissionTypes(
customModelId?: number,
): CancelablePromise<CarMinFilter> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetFuelAndTransmissionTypes',
      query: {
        'customModelId': customModelId,
      },
    });
  }

  /**
   * @param sortCode 
   * @param accountNumber 
   * @returns BankAccountResponseDto Success
   * @throws ApiError
   */
  public static getLookupBankAccount(
sortCode?: string,
accountNumber?: string,
): CancelablePromise<BankAccountResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/LookupBankAccount',
      query: {
        'sortCode': sortCode,
        'accountNumber': accountNumber,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCommonSendSmsCode(
requestBody?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Common/SendSmsCode',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param phone 
   * @param code 
   * @returns any Success
   * @throws ApiError
   */
  public static getCommonCheckSmsCode(
phone?: string,
code?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Common/CheckSmsCode',
      query: {
        'phone': phone,
        'code': code,
      },
    });
  }

  /**
   * @returns TradeInConditionDto Success
   * @throws ApiError
   */
  public static getGetTradeInCarConditions(): CancelablePromise<Array<TradeInConditionDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetTradeInCarConditions',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns string Success
   * @throws ApiError
   */
  public static postSvcFeedbackSave(
requestBody?: SvcFeedbackRequest,
): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SvcFeedbackSave',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param email 
   * @returns any Created
   * @throws ApiError
   */
  public static postUnsubscribe(
email: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Unsubscribe',
      query: {
        'email': email,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param regNo 
   * @returns VehicleData Success
   * @throws ApiError
   */
  public static getLookupGovDvlaTax(
regNo?: string,
): CancelablePromise<VehicleData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/LookupGovDvlaTax',
      query: {
        'regNo': regNo,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param url 
   * @returns VehicleData Success
   * @throws ApiError
   */
  public static getGetRenderedPhoto(
url?: string,
): CancelablePromise<VehicleData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetRenderedPhoto',
      query: {
        'url': url,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @returns HealthCheckResultModel Success
   * @throws ApiError
   */
  public static getHealthCheck(): CancelablePromise<HealthCheckResultModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/HealthCheck',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param manufacturer 
   * @param model 
   * @param salesHistoryMonthCount 
   * @param transmission 
   * @param fuelType 
   * @param trim 
   * @param age 
   * @param branchId 
   * @returns LookupStockInfoResponse Success
   * @throws ApiError
   */
  public static getLookupStockCarInfo(
manufacturer: string,
model: string,
salesHistoryMonthCount: number,
transmission?: string,
fuelType?: string,
trim?: string,
age?: number,
branchId?: number,
): CancelablePromise<LookupStockInfoResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/LookupStockCarInfo',
      query: {
        'Manufacturer': manufacturer,
        'Model': model,
        'SalesHistoryMonthCount': salesHistoryMonthCount,
        'Transmission': transmission,
        'FuelType': fuelType,
        'Trim': trim,
        'Age': age,
        'BranchId': branchId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @returns ActiveModel Success
   * @throws ApiError
   */
  public static getGetActiveModels(): CancelablePromise<Array<ActiveModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetActiveModels',
      errors: {
        500: `Server Error`,
      },
    });
  }

  /**
   * @param regNo 
   * @param userRequestId 
   * @returns any Success
   * @throws ApiError
   */
  public static getLookUpFullCapHpiByRegno(
regNo: string,
userRequestId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/LookUpFullCapHpiByRegno',
      query: {
        'regNo': regNo,
        'userRequestId': userRequestId,
      },
    });
  }

  /**
   * @param regNo 
   * @returns any Success
   * @throws ApiError
   */
  public static getGetFullCapHpiHistoryByRegno(
regNo: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetFullCapHpiHistoryByRegno',
      query: {
        'regNo': regNo,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static getLookUpFullCapHpiId(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/LookUpFullCapHpiId/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param vrm 
   * @param vin 
   * @param source 
   * @returns CapHpiDvlaDTO Success
   * @throws ApiError
   */
  public static getLookupCapHpi(
vrm?: string,
vin?: string,
source: string = '',
): CancelablePromise<CapHpiDvlaDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/LookupCapHpi',
      query: {
        'vrm': vrm,
        'vin': vin,
        'source': source,
      },
    });
  }

  /**
   * @param code 
   * @returns LookUpUserDto Success
   * @throws ApiError
   */
  public static getLookUpUser(
code: string,
): CancelablePromise<LookUpUserDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/LookUpUser/{code}',
      path: {
        'code': code,
      },
    });
  }

  /**
   * @param codes 
   * @returns LookUpUserDto Success
   * @throws ApiError
   */
  public static getLookUpUsers(
codes?: Array<string>,
): CancelablePromise<Array<LookUpUserDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/LookUpUsers',
      query: {
        'codes': codes,
      },
    });
  }

  /**
   * @param phone 
   * @param message 
   * @param templateId 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postSendSms(
phone: string,
message: string,
templateId?: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SendSms',
      query: {
        'phone': phone,
        'message': message,
        'templateId': templateId,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postSendMms(
requestBody?: SendMmsInput,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SendMms',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param requestBody 
   * @returns SmsTemplateDto Success
   * @throws ApiError
   */
  public static postGetSmsTemplate(
requestBody?: BaseSmsTemplate,
): CancelablePromise<SmsTemplateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/GetSmsTemplate',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param formData 
   * @returns string Success
   * @throws ApiError
   */
  public static postCreateShortUrl(
formData?: {
url: string;
},
): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CreateShortUrl',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param caller 
   * @returns ApiQueryLog Success
   * @throws ApiError
   */
  public static getCommonGetLogs(
caller?: string,
): CancelablePromise<Array<ApiQueryLog>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Common/GetLogs',
      query: {
        'caller': caller,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns string Success
   * @throws ApiError
   */
  public static postCommonUpdateYoutubeVideo(
requestBody?: YoutubeUpdateInput,
): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Common/update-youtube-video',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param formData 
   * @returns string Success
   * @throws ApiError
   */
  public static postCommonUploadYoutubeVideo(
formData?: {
File: Blob;
Title: string;
CutAudio: boolean;
},
): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Common/upload-youtube-video',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param policyId 
   * @returns string Success
   * @throws ApiError
   */
  public static putCommonUpdatePolicy(
policyId: number,
): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Common/update-policy/{policyId}',
      path: {
        'policyId': policyId,
      },
    });
  }

  /**
   * @param policyId 
   * @returns string Success
   * @throws ApiError
   */
  public static putCommonGardSendPolicy(
policyId: number,
): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Common/gard-send-policy/{policyId}',
      path: {
        'policyId': policyId,
      },
    });
  }

  /**
   * Get vehicle info by reg number and update it in CDK
   * @param regNo Reg Number
   * @returns ResponseVehicleData Success
   * @throws ApiError
   */
  public static getCommonLookUpAndUpdateVehicle(
regNo?: string,
): CancelablePromise<ResponseVehicleData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/look-up-and-update-vehicle',
      query: {
        'regNo': regNo,
      },
    });
  }

  /**
   * @returns ReferenceUnitMeasurementDto Success
   * @throws ApiError
   */
  public static getCommonReferenceUnitMeasurements(): CancelablePromise<Array<ReferenceUnitMeasurementDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Common/reference-unit-measurements',
    });
  }

  /**
   * @param requestBody 
   * @returns void 
   * @throws ApiError
   */
  public static postCommonLog(
requestBody?: LogInput,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/log',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param typeId 
   * @returns FAQLog Success
   * @throws ApiError
   */
  public static getCommonFaq(
typeId?: number,
): CancelablePromise<FAQLog> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/faq',
      query: {
        'typeId': typeId,
      },
    });
  }

  /**
   * @returns FAQLogType Success
   * @throws ApiError
   */
  public static getCommonFaqTypes(): CancelablePromise<Array<FAQLogType>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/faq-types',
    });
  }

  /**
   * @param requestBody 
   * @returns any Created
   * @throws ApiError
   */
  public static postCommonExternalContractor(
requestBody?: ExternalContractorInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/external-contractor',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param name 
   * @param typeId
 *
 * 0 = Other
 *
 * 1 = Parts
 *
 * 2 = Vehicles
 *
 * 3 = VehicleDelivery
 *
 * 4 = BuildingMaintenance
 *
 * 5 = ServiceEquipmentMaintenance
 *
 * 6 = ITAndNetwork
 *
 * 7 = SmartRepair
 *
 * 8 = VehicleAdditionalEquipment
 *
 * 9 = Uniform
 *
 * 10 = Stationary
 *
 * 11 = Bodywork
 *
 * 12 = EquipmentAndTools
   * @param sort 
   * @param order
 *
 * 0 = ASC
 *
 * 1 = DESC
   * @param skipPagination Пропустить пагинацию
   * @param page Страница
   * @param maxCount Максимально количество записей на странице
   * @returns ExternalContractorDtoPagedListData Success
   * @throws ApiError
   */
  public static getCommonExternalContractor(
name?: string,
typeId?: SupplierTypeEnum,
sort?: string,
order?: SortTypeEnum,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<ExternalContractorDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/external-contractor',
      query: {
        'Name': name,
        'TypeId': typeId,
        'Sort': sort,
        'Order': order,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
    });
  }

  /**
   * @param departmentId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCommonSmsTemplates(
departmentId: number,
requestBody?: SmsTemplateParams,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/sms-templates/{departmentId}',
      path: {
        'departmentId': departmentId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCommonWipServicePdf(
requestBody?: WipServicePdfModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/wip-service-pdf',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param wipNo 
   * @param regNo 
   * @param serivceType
 *
 * 0 = Other
 *
 * 1 = Parts
 *
 * 2 = ServiceSchedule
 *
 * 3 = Recall
 *
 * 4 = CIF
   * @param formData 
   * @returns string Success
   * @throws ApiError
   */
  public static postCommonWipServicePdfFile(
wipNo?: number,
regNo?: string,
serivceType?: WipServicePdfTypeEnum,
formData?: {
pdfFile?: Blob;
},
): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/wip-service-pdf-file',
      query: {
        'wipNo': wipNo,
        'regNo': regNo,
        'serivceType': serivceType,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param id 
   * @param userId 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteCommonWipServicePdf(
id: number,
userId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/common/{id}/wip-service-pdf',
      path: {
        'id': id,
      },
      query: {
        'userId': userId,
      },
    });
  }

  /**
   * @param vin 
   * @param vehId 
   * @returns ParsedEsaModel Success
   * @throws ApiError
   */
  public static getCommonEsaServiceHistory(
vin?: string,
vehId?: number,
): CancelablePromise<Array<ParsedEsaModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/esa-service-history',
      query: {
        'vin': vin,
        'vehId': vehId,
      },
    });
  }

  /**
   * @returns TransportOptionModel Success
   * @throws ApiError
   */
  public static getCommonTransportOptions(): CancelablePromise<Array<TransportOptionModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/transport-options',
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postCommonTransportOptions(
requestBody?: TransportOptionSubmitModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/transport-options',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static patchCommonTransportOptions(
id: number,
requestBody?: TransportOptionSubmitModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/common/{id}/transport-options',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @returns SoPartStatusDto Success
   * @throws ApiError
   */
  public static getCommonSoPartStatuses(): CancelablePromise<Array<SoPartStatusDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/so-part-statuses',
    });
  }

  /**
   * @param vin 
   * @returns RacContractModel Success
   * @throws ApiError
   */
  public static getCommonRac(
vin: string,
): CancelablePromise<RacContractModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/rac/{vin}',
      path: {
        'vin': vin,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param vrm 
   * @returns ResponseVehicleData Success
   * @throws ApiError
   */
  public static getCommonVehicleData(
vrm?: string,
): CancelablePromise<ResponseVehicleData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/vehicle-data',
      query: {
        'vrm': vrm,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param vin 
   * @returns ResponseVehicleData Success
   * @throws ApiError
   */
  public static getCommonVehicleDataVin(
vin?: string,
): CancelablePromise<ResponseVehicleData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/vehicle-data/vin',
      query: {
        'vin': vin,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static postCommonUploadVehiclesToGoogle(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Common/UploadVehiclesToGoogle',
    });
  }

  /**
   * @returns ShortCustomModelDTO Success
   * @throws ApiError
   */
  public static getCommonCustomModels(): CancelablePromise<Array<ShortCustomModelDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/custom-models',
    });
  }

  /**
   * @param customModelId 
   * @returns ShortTrimStyleDTO Success
   * @throws ApiError
   */
  public static getCommonCustomModelsTrims(
customModelId: number,
): CancelablePromise<Array<ShortTrimStyleDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/custom-models/{customModelId}/trims',
      path: {
        'customModelId': customModelId,
      },
    });
  }

  /**
   * @param customModelId 
   * @returns TrimStyleDTO Success
   * @throws ApiError
   */
  public static getCommonCustomModelsFullTrims(
customModelId: number,
): CancelablePromise<Array<TrimStyleDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/custom-models/{customModelId}/full-trims',
      path: {
        'customModelId': customModelId,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postCommonLabour(
requestBody?: LabourSubmitModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/labour',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param dateFrom 
   * @param dateTo 
   * @param labourCode 
   * @param labourDescription 
   * @param isActive 
   * @returns LabourDetailsModel Success
   * @throws ApiError
   */
  public static getCommonLabour(
dateFrom?: string,
dateTo?: string,
labourCode?: string,
labourDescription?: string,
isActive?: boolean,
): CancelablePromise<Array<LabourDetailsModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/labour',
      query: {
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'LabourCode': labourCode,
        'LabourDescription': labourDescription,
        'IsActive': isActive,
      },
    });
  }

  /**
   * @returns string Success
   * @throws ApiError
   */
  public static getCommonLaboursDictionary(): CancelablePromise<Record<string, string>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/labours/dictionary',
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static patchCommonLabour(
id: number,
requestBody?: LabourSubmitModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/common/{id}/labour',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteCommonLabour(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/common/{id}/labour',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param labourCode 
   * @returns LabourDetailsModel Success
   * @throws ApiError
   */
  public static getCommonGetLabourByCode(
labourCode?: string,
): CancelablePromise<LabourDetailsModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/get-labour-by-code',
      query: {
        'labourCode': labourCode,
      },
    });
  }

  /**
   * @param labourCodes 
   * @returns LabourDetailsModel Success
   * @throws ApiError
   */
  public static getCommonGetLaboursByCodes(
labourCodes?: Array<string>,
): CancelablePromise<Array<LabourDetailsModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/get-labours-by-codes',
      query: {
        'labourCodes': labourCodes,
      },
    });
  }

  /**
   * @param branchId 
   * @returns SoOperModel Success
   * @throws ApiError
   */
  public static getCommonOpersByBranch(
branchId?: number,
): CancelablePromise<Array<SoOperModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/opers-by-branch',
      query: {
        'branchId': branchId,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postCommonUpdateSoheaderDates(
requestBody?: SoHeaderDueDatesUpdateModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/update-soheader-dates',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postCommonUpdateSoheaderRepairOrder(
requestBody?: SoHeaderRepairOrderUpdateModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/update-soheader-repair-order',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postCommonWipBookingType(
requestBody?: BookingTypeSubmitModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/wip-booking-type',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param regNo 
   * @param wipNo 
   * @param branchId 
   * @param soHeaderId 
   * @returns CreateRepairOrderResponse Success
   * @throws ApiError
   */
  public static getCommonRepairOrder(
regNo?: string,
wipNo?: number,
branchId?: number,
soHeaderId?: number,
): CancelablePromise<CreateRepairOrderResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/repair-order',
      query: {
        'regNo': regNo,
        'wipNo': wipNo,
        'branchId': branchId,
        'soHeaderId': soHeaderId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns RepairOrderQuoteModel Success
   * @throws ApiError
   */
  public static getCommonRepairOrderQuotes(
soHeaderId?: number,
): CancelablePromise<Array<RepairOrderQuoteModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/repair-order-quotes',
      query: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postCommonRepairOrderQuotes(
requestBody?: RepairOrderQuoteSubmitModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/repair-order-quotes',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static putCommonRepairOrderQuotes(
requestBody?: RepairOrderQuoteSubmitModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/common/repair-order-quotes',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns RepairOrderQuoteModel Success
   * @throws ApiError
   */
  public static getCommonRepairOrderQuotes1(
id: number,
): CancelablePromise<RepairOrderQuoteModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/{id}/repair-order-quotes',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param quoteId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postCommonRepairOrderQuoteLabour(
quoteId: number,
requestBody?: RepairOrderQuoteLabourSubmitModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/{quoteId}/repair-order-quote-labour',
      path: {
        'quoteId': quoteId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putCommonRepairOrderQuoteLabour(
id: number,
requestBody?: RepairOrderQuoteLabourSubmitModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/common/{id}/repair-order-quote-labour',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param userId 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteCommonRepairOrderQuoteLabour(
id: number,
userId?: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/common/{id}/repair-order-quote-labour',
      path: {
        'id': id,
      },
      query: {
        'userId': userId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Created
   * @throws ApiError
   */
  public static postCommonWipInfoQuotePart(
requestBody?: PartRequestWipInfoInputModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/wip-info-quote-part',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putCommonWipInfoQuotePart(
id: number,
requestBody?: PartRequestWipInfoInputModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/common/{id}/wip-info-quote-part',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param quoteId 
   * @param requestBody 
   * @returns RepairOrderQuotePartCreateResponseModel Created
   * @throws ApiError
   */
  public static postCommonRepairOrderQuotePart(
quoteId: number,
requestBody?: RepairOrderQuotePartSubmitModel,
): CancelablePromise<RepairOrderQuotePartCreateResponseModel> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/{quoteId}/repair-order-quote-part',
      path: {
        'quoteId': quoteId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putCommonRepairOrderQuotePart(
id: number,
requestBody?: RepairOrderQuotePartSubmitModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/common/{id}/repair-order-quote-part',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param userId 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteCommonRepairOrderQuotePart(
id: number,
userId?: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/common/{id}/repair-order-quote-part',
      path: {
        'id': id,
      },
      query: {
        'userId': userId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteCommonRepairOrderQuoteNote(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/common/{id}/repair-order-quote-note',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postCommonRepairOrderQuoteStatus(
requestBody?: RepairOrderQuoteStatusSubmitModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/repair-order-quote-status',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns RepairOrderQuoteStatusModel Success
   * @throws ApiError
   */
  public static getCommonRepairOrderQuoteStatus(
id?: number,
): CancelablePromise<RepairOrderQuoteStatusModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/repair-order-quote-status',
      query: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param userId 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postCommonRepairOrderJobFromQuote(
id: number,
userId?: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/{id}/repair-order-job-from-quote',
      path: {
        'id': id,
      },
      query: {
        'userId': userId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteCommonRepairOrderQuote(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/common/{id}/repair-order-quote',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns RepairOrderQuoteClientModel Success
   * @throws ApiError
   */
  public static getCommonRepairOrderQuotesClient(
id: number,
): CancelablePromise<RepairOrderQuoteClientModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/{id}/repair-order-quotes-client',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postCommonRepairOrderQuotesClient(
id: number,
requestBody?: RepairOrderQuoteClientSubmitModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/{id}/repair-order-quotes-client',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @returns boolean Success
   * @throws ApiError
   */
  public static getCommonSendRepairOrderQuotesDocumentScheduler(): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/send-repair-order-quotes-document-scheduler',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postCommonRepairOrderQuotesAuthorize(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/{id}/repair-order-quotes-authorize',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param manufacturer 
   * @param model 
   * @param modelYear 
   * @param vrm 
   * @param vehClass 
   * @returns VariantCodeModel Success
   * @throws ApiError
   */
  public static getCommonVariantCode(
manufacturer?: string,
model?: string,
modelYear?: number,
vrm?: string,
vehClass?: string,
): CancelablePromise<Array<VariantCodeModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/variant-code',
      query: {
        'manufacturer': manufacturer,
        'model': model,
        'modelYear': modelYear,
        'vrm': vrm,
        'vehClass': vehClass,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postCommonSetWipClosed(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/{id}/set-wip-closed',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param vehicleLocation 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postCommonSetWipVehicleLocation(
id: number,
vehicleLocation?: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/{id}/set-wip-vehicle-location',
      path: {
        'id': id,
      },
      query: {
        'vehicleLocation': vehicleLocation,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param keyTag 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postCommonSetWipKeyTag(
id: number,
keyTag?: string,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/{id}/set-wip-key-tag',
      path: {
        'id': id,
      },
      query: {
        'keyTag': keyTag,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param wipNo 
   * @param regno 
   * @param branchId 
   * @returns number Success
   * @throws ApiError
   */
  public static getCommonFindSoheaderId(
wipNo?: number,
regno?: string,
branchId?: number,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/find-soheader-id',
      query: {
        'wipNo': wipNo,
        'regno': regno,
        'branchId': branchId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param manufacturer 
   * @returns number Success
   * @throws ApiError
   */
  public static getCommonManufacturerId(
manufacturer?: string,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/manufacturer-id',
      query: {
        'manufacturer': manufacturer,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param vin 
   * @param mileage 
   * @param soHeaderId 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postCommonFindVehicleAndUpdateCdkMileage(
vin?: string,
mileage?: number,
soHeaderId?: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/find-vehicle-and-update-cdk-mileage',
      query: {
        'vin': vin,
        'mileage': mileage,
        'soHeaderId': soHeaderId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postCommonSoHeaderTrackerStatus(
requestBody?: SoHeaderTrackerSubmitModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/so-header-tracker-status',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns SoHeaderTrackerModel Success
   * @throws ApiError
   */
  public static getCommonSoHeaderTrackerStatus(
id: number,
): CancelablePromise<Array<SoHeaderTrackerModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/{id}/so-header-tracker-status',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @returns boolean Success
   * @throws ApiError
   */
  public static postCommonCheckPartOrdersForTrackerStatus(): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/check-part-orders-for-tracker-status',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postCommonSaveSoHeaderRepairOrder(
requestBody?: RepairOrderSubmitModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/save-so-header-repair-order',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @returns BrandCodeDto Success
   * @throws ApiError
   */
  public static getCommonBrands(): CancelablePromise<Array<BrandCodeDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/brands',
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static postCommonSetPauseToClockings(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/set-pause-to-clockings',
    });
  }

  /**
   * @param dateFrom 
   * @param dateTo 
   * @param branchId 
   * @returns string Success
   * @throws ApiError
   */
  public static getCommonTechClockingCsv(
dateFrom?: string,
dateTo?: string,
branchId?: number,
): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/tech-clocking-csv',
      query: {
        'dateFrom': dateFrom,
        'dateTo': dateTo,
        'branchId': branchId,
      },
    });
  }

  /**
   * @param id 
   * @returns SoHeaderInnerRepairOrderJobModel Success
   * @throws ApiError
   */
  public static getCommonSoHeaderInnerJobs(
id: number,
): CancelablePromise<Array<SoHeaderInnerRepairOrderJobModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/{id}/so-header-inner-jobs',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteCommonSoHeaderInnerJobPart(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/common/{id}/so-header-inner-job-part',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns boolean Success
   * @throws ApiError
   */
  public static postCommonCheckCdkJobsFromQuotesForInvoice(): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/check-cdk-jobs-from-quotes-for-invoice',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns void 
   * @throws ApiError
   */
  public static getCommonRepairOrderReportPdf(
soHeaderId?: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/repair-order-report-pdf',
      query: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param regno 
   * @param email 
   * @returns VoucherModel Success
   * @throws ApiError
   */
  public static getCommonVouchers(
regno?: string,
email?: string,
): CancelablePromise<Array<VoucherModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/vouchers',
      query: {
        'regno': regno,
        'email': email,
      },
    });
  }

  /**
   * @param id 
   * @returns ConvertedPartPdfFullModel Success
   * @throws ApiError
   */
  public static getCommonConvertedServicePartPdf(
id: number,
): CancelablePromise<ConvertedPartPdfFullModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/{id}/converted-service-part-pdf',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putCommonConvertedServicePartPdfPartLine(
id: number,
requestBody?: ConvertedServicePartPdfGroupPartSubmitModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/common/{id}/converted-service-part-pdf-part-line',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putCommonConvertedServicePartPdfLabourLine(
id: number,
requestBody?: ConvertedServicePartPdfGroupLabourSubmitModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/common/{id}/converted-service-part-pdf-labour-line',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putCommonConvertedServicePartPdf(
requestBody?: ConvertedServicePartPdfSubmitModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/common/converted-service-part-pdf',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param userId 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postCommonCdkJobFromConvertedPartPdf(
id: number,
userId?: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/{id}/cdk-job-from-converted-part-pdf',
      path: {
        'id': id,
      },
      query: {
        'userId': userId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @returns AppointmentTypeModel Success
   * @throws ApiError
   */
  public static getCommonAppointmentTypes(): CancelablePromise<Array<AppointmentTypeModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/appointment-types',
    });
  }

  /**
   * @returns number Success
   * @throws ApiError
   */
  public static getCommonLabourRate(): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/labour-rate',
    });
  }

  /**
   * @param labourId 
   * @param jobType
 *
 * 1 = Retail
 *
 * 2 = Internal
 *
 * 3 = Warranty
 *
 * 4 = Fleet
   * @param branchId 
   * @param manufactureCrmId 
   * @param calculateWithVat 
   * @returns number Success
   * @throws ApiError
   */
  public static getCommonGetPriceForLabour(
labourId?: number,
jobType?: WarrantyJobTypeEnum,
branchId?: number,
manufactureCrmId?: number,
calculateWithVat?: boolean,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/get-price-for-labour',
      query: {
        'labourId': labourId,
        'JobType': jobType,
        'BranchId': branchId,
        'ManufactureCrmId': manufactureCrmId,
        'CalculateWithVat': calculateWithVat,
      },
    });
  }

  /**
   * @returns ManufacturerDto Success
   * @throws ApiError
   */
  public static getCommonGetManufactures(): CancelablePromise<Array<ManufacturerDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/get-manufactures',
    });
  }

  /**
   * @returns ServiceHistoryCheckTypeModel Success
   * @throws ApiError
   */
  public static getCommonServiceHistoryTypes(): CancelablePromise<Array<ServiceHistoryCheckTypeModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/service-history-types',
    });
  }

  /**
   * @param regNo 
   * @returns ServiceHistoryCheckModel Success
   * @throws ApiError
   */
  public static getCommonServiceHistoryCheck(
regNo?: string,
): CancelablePromise<ServiceHistoryCheckModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/service-history-check',
      query: {
        'regNo': regNo,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postCommonServiceHistoryCheck(
requestBody?: ServiceHistoryCheckSubmitModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/common/service-history-check',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param regNo 
   * @returns ShortSoHeaderInfoModel Success
   * @throws ApiError
   */
  public static getCommonFindSoHeadersByRegno(
regNo?: string,
): CancelablePromise<Array<ShortSoHeaderInfoModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/common/find-so-headers-by-regno',
      query: {
        'regNo': regNo,
      },
    });
  }

}
